import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../helper/Api";
import Toastify from "../helper/Toastify";




export const getAllOrdersThunk = createAsyncThunk(
    'orders/getAllOrders',
    async ({ page = 1, size = 10, sort = 'newest' } = {}, { rejectWithValue }) => {
        try {
            const response = await api.getAllOrders({ page, size, sort });
            return response.data.data;
        } catch (err) {
            const message = err.response?.data?.message || 'Something went wrong. Please try again later.';
            return rejectWithValue(message);
        }
    }
);


export const getOrderDetailsThunk = createAsyncThunk('getOrderDetails', async (body, { rejectWithValue, dispatch }) => {
    try {
        const { data, status } = await api.getOrderDetails(body);

        return data.data
    } catch (err) {
        // Toastify.error(err.response.data.message)
        return rejectWithValue(err.response.data.message || "'Something went wrong. Please try again later.'")
    }
}
)






export const orderSlice = createSlice({
    name: "orders",
    initialState: {
        isLoading: false,
        isRefresh: false,
        orders: [],
        pagination: {
          totalOrders: 0,
          totalPages: 0,
          pageOrders: 0,
          isFirst: true,
          isLast: false,
          hasNext: false,
          hasPrevious: false,
        },
        orderDetails: {}
    },
    reducers: {

        setOrderRefresh: (state) => {
            state.isRefresh = !state.isRefresh
        },

    },
    extraReducers: (builder) => {

        builder
        .addCase(getAllOrdersThunk.pending, (state) => {
          state.isLoading = true;
          state.error = null;
        })
        .addCase(getAllOrdersThunk.fulfilled, (state, action) => {
          state.isLoading = false;
          state.orders = action.payload.orders;
          state.pagination = {
            totalOrders: action.payload.totalOrders,
            totalPages: action.payload.totalPages,
            pageOrders: action.payload.pageOrders,
            isFirst: action.payload.isFirst,
            isLast: action.payload.isLast,
            hasNext: action.payload.hasNext,
            hasPrevious: action.payload.hasPrevious
          };
        })
        .addCase(getAllOrdersThunk.rejected, (state, action) => {
          state.isLoading = false;
          state.error = action.payload;
        })

        builder.addCase(getOrderDetailsThunk.pending, (state) => {
            state.isLoading = true
        })
        builder.addCase(getOrderDetailsThunk.fulfilled, (state, action) => {
            state.isLoading = false
            state.orderDetails = action.payload
        })
        builder.addCase(getOrderDetailsThunk.rejected, (state, action) => {
            state.isLoading = false
        })

    }
})

export const {
    setOrderRefresh
} = orderSlice.actions

export default orderSlice.reducer;